import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';

import FancyDropdown, {
  FancyDropdownMenu,
  FancyDropdownMenuItem
} from 'dpl/components/FancyDropdown';
import Icon from 'dpl/common/components/Icon';
import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { GDButtonV1 } from 'dpl/common/core/GDButton/GDButtonV1';

import { LitterOverviewCardV1 } from './LitterOverviewCardV1';
import {
  activeLittersV1QueryDefinition,
  buyerAssignedLitterV1QueryDefinition
} from '../utils/queryDefinitions';

export function AssignBuyerToLitterInputV1({
  buyerProfile,
  className,
  onChange
}) {
  const { value: assignedLitter } = useResourceQuery(
    buyerAssignedLitterV1QueryDefinition({ id: buyerProfile.id })
  );

  const [selectedLitter, setSelectedLitter] = useState(null);

  useEffect(() => {
    setSelectedLitter(assignedLitter);
  }, [assignedLitter?.id]);

  useEffect(() => {
    onChange(selectedLitter);
  }, [selectedLitter?.id]);

  const { value: litters = [] } = useResourceQuery(
    activeLittersV1QueryDefinition()
  );

  const [isOpen, setIsOpen] = useState(false);

  return (
    <article
      className={classnames('f2 flex flex-column', className)}
      style={{ gap: '0.5rem' }}
    >
      <h2 className="f2">Assign a litter (optional)</h2>
      <p>
        Assign a litter to {buyerProfile.full_name} to help keep track of your
        Good Dog buyers. This assignment won&apos;t be final and you can change
        it anytime.
      </p>
      <FancyDropdown isOpen={isOpen} onChange={setIsOpen}>
        <GDButtonV1
          outlined
          variant="secondary"
          className="w-100 b--lightest-gray justify-between"
          onClick={() => {
            setIsOpen(!isOpen);
          }}
        >
          {selectedLitter?.id ? (
            <>
              <span className="sr-only">
                {buyerProfile.full_name} is currently assigned to the litter{' '}
                {selectedLitter.name}.
              </span>
              <LitterOverviewCardV1
                litter={selectedLitter}
                className="flex items-center justify-between"
              />
            </>
          ) : (
            <>Select a litter</>
          )}
          <Icon
            height="18px"
            name={`arrow-${isOpen ? 'up' : 'down'}`}
            width="18px"
          />
        </GDButtonV1>
        {Array.isArray(litters) && (
          <FancyDropdownMenu contentClassName="pv2">
            {litters.map((litter, index) => (
              <FancyDropdownMenuItem itemKey={litter.id} key={litter.id}>
                <button
                  className="w-100 bg-white"
                  onClick={() => {
                    setSelectedLitter(litter);
                  }}
                  type="button"
                >
                  <LitterOverviewCardV1
                    className={classnames(
                      'ph6 pv6 bb br bl b--lightest-gray ',
                      {
                        bt: index === 0
                      }
                    )}
                    litter={litter}
                  />
                </button>
              </FancyDropdownMenuItem>
            ))}
          </FancyDropdownMenu>
        )}
      </FancyDropdown>
    </article>
  );
}

AssignBuyerToLitterInputV1.propTypes = {
  buyerProfile: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    full_name: PropTypes.string.isRequired
  }).isRequired,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired
};

AssignBuyerToLitterInputV1.defaultProps = {
  className: null
};
